"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeFilter = exports.rawDateFilter = exports.dateFilter = void 0;
var _dateFns = require("date-fns");
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var typeFilter = exports.typeFilter = function typeFilter(item, selectedType) {
  var value = (0, _get["default"])(item, 'Type');
  if (!value) {
    console.warn('recent activity item does not have a type:', item);
    return false;
  }
  if (selectedType !== 'all') {
    return value === selectedType;
  } else {
    return true;
  }
};
var dateFilter = exports.dateFilter = function dateFilter(item) {
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var rawTimeStamp = (0, _get["default"])(item, 'TimeStamp.raw');
  if (!rawTimeStamp) {
    console.warn('recent activity item does not have a TimeStamp.raw property:', item);
    return false;
  }
  if ((0, _dateFns.isDate)(startDate) && (0, _dateFns.isDate)(endDate)) {
    try {
      return (0, _dateFns.isWithinInterval)(new Date(rawTimeStamp), {
        start: startDate,
        end: (0, _dateFns.addDays)(endDate, 1)
      });
    } catch (_unused) {
      return false;
    }
  }
  try {
    return (0, _dateFns.isWithinInterval)(new Date(rawTimeStamp), {
      start: new Date(0),
      end: new Date()
    });
  } catch (_unused2) {
    return false;
  }
};
var rawDateFilter = exports.rawDateFilter = function rawDateFilter(item) {
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var rawTimeStamp = (0, _get["default"])(item, 'TimeStamp');
  if (!rawTimeStamp) {
    console.warn('recent activity item does not have a TimeStamp property:', item);
    return false;
  }
  if ((0, _dateFns.isDate)(startDate) && (0, _dateFns.isDate)(endDate)) {
    try {
      return (0, _dateFns.isWithinInterval)(new Date(rawTimeStamp), {
        start: startDate,
        end: (0, _dateFns.addDays)(endDate, 1)
      });
    } catch (_unused3) {
      return false;
    }
  }
  try {
    return (0, _dateFns.isWithinInterval)(new Date(rawTimeStamp), {
      start: new Date(0),
      end: new Date()
    });
  } catch (_unused4) {
    return false;
  }
};